import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=4dfc2f9c&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfc2f9c')) {
      api.createRecord('4dfc2f9c', component.options)
    } else {
      api.reload('4dfc2f9c', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=4dfc2f9c&", function () {
      api.rerender('4dfc2f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/MenuItem.vue"
export default component.exports